import { render, staticRenderFns } from "./TitleTextContentsLayout.vue?vue&type=template&id=23c06331&scoped=true&"
import script from "./TitleTextContentsLayout.vue?vue&type=script&lang=js&"
export * from "./TitleTextContentsLayout.vue?vue&type=script&lang=js&"
import style0 from "./TitleTextContentsLayout.vue?vue&type=style&index=0&id=23c06331&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c06331",
  null
  
)

export default component.exports